import { Component, ComponentFactoryResolver, Injector, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudEditComponent, CrudEditorParentService, CrudEditorSelfService, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { FirearmStorageLocation } from 'assets-model';


@Component({
  selector: 'app-firearm-storage-location-editor',
  templateUrl: '../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.html',
  styleUrls: ['../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.css'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class FirearmStorageLocationEditorComponent extends CrudEditComponent<FirearmStorageLocation, number> implements OnInit {

  constructor(
    route: ActivatedRoute,
    router: Router,
    userStorage: UserStorage,
    dialog: MatDialog,
    snackbar: MatSnackBar,
    componentFactoryResolver: ComponentFactoryResolver,
    injector: Injector,
    private formStorage: FormStorage) {
    super(route, router, userStorage, dialog, snackbar, componentFactoryResolver, injector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  itemSet() {
    super.itemSet();
    const self = this;
    this.actions = [{
      title: 'PLI', color: true,
      get available() {
        return !self.createMode && self.item?.locationType === 'G'
          && self.userStorage.currentUserHasAnyAuthority('READ_FIREARM_STORAGE_LOCATION_PLI');
      },
      get enabled() { return !self.unsavedChanges(); },
      doAction() {
        return self.router.navigate(['/firearmstoragelocationpli/search', self.item.firearmStorageLocationId]);
      }
    }];
  }


}






